import React, { useEffect } from 'react';
import { Box, Container, Typography, Card, CardContent, Grid, Chip, Stack, Button } from '@mui/material';
import { Check, Handyman } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const FacturationArtisan = () => {
  const navigate = useNavigate();

  const goToRegisterTracked = () => {
    const params = new URLSearchParams({
      utm_source: 'site_facteio',
      utm_medium: 'cta',
      utm_campaign: 'facturation_artisan',
      utm_content: 'cta_page'
    });
    navigate(`/register?${params.toString()}`);
  };

  useEffect(() => {
    document.title = 'Logiciel devis facture artisan | Facteio';
    const description = 'Facturation artisan: devis clairs, suivi intervention, ligne main d’œuvre/fournitures et documents conformes.';
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description);
  }, []);

  return (
    <Box sx={(theme) => ({ background: theme.palette.background.default, minHeight: '100vh', py: 5 })}>
      <Container maxWidth="lg">
        <Button variant="text" onClick={() => navigate('/')} sx={{ mb: 2, fontWeight: 600 }}>← Retour à l'accueil</Button>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" mb={2}>
          <Chip icon={<Handyman />} label="Facturation Artisan" sx={{ bgcolor: '#E5E8EE', color: '#1F2937' }} />
          <Chip icon={<Check />} label="Discours métier" />
          <Chip icon={<Check />} label="SEO + Ads ciblées" />
        </Stack>

        <Typography variant="h3" fontWeight={800} mb={1}>Artisan & commerce: facturez sans friction</Typography>
        <Typography variant="h6" color="text.secondary" mb={4}>
          Électricien, plombier, menuisier, commerce de proximité: des documents précis, rapides et adaptés à votre activité.
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card><CardContent>
              <Typography variant="h6" fontWeight={700} mb={2}>Artisan (terrain)</Typography>
              <Typography>• Modèles adaptés interventions et chantiers</Typography>
              <Typography>• Suivi simple des montants et statuts</Typography>
              <Typography>• Documents pro prêts à envoyer</Typography>
            </CardContent></Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card><CardContent>
              <Typography variant="h6" fontWeight={700} mb={2}>Commerce (vente)</Typography>
              <Typography>• Factures avec gestion produits</Typography>
              <Typography>• Stock simplifié</Typography>
              <Typography>• TVA multiple prête à l’emploi</Typography>
            </CardContent></Card>
          </Grid>
        </Grid>

        <Card sx={{ mt: 4, border: '1px solid #D5CDC3' }}>
          <CardContent sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h5" fontWeight={800} mb={1}>
              Moins de paperasse, plus de temps client
            </Typography>
            <Typography color="text.secondary" mb={2}>
              Même si vous n’aimez pas l’administratif: vos devis et factures restent lisibles et rapides à sortir.
            </Typography>
            <Button
              variant="contained"
              sx={{ background: 'linear-gradient(135deg, #1F2937 0%, #4B5563 100%)' }}
              onClick={goToRegisterTracked}
            >
              Essayer Facteio pour Artisan & Commerce
            </Button>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default FacturationArtisan;
